import { Route } from 'react-router-dom';

import { RoomTypeDetailPage } from './pages/room-type-detail-page.js';
import { RoomTypeFormPage } from './pages/room-type-form-page.js';
import { RoomTypeListPage } from './pages/room-type-list-page.js';

export function roomTypeRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/room-types" element={<RoomTypeListPage />} />
      <Route path="/room-types/new" element={<RoomTypeFormPage />} />
      <Route path="/room-types/:roomTypeId/edit" element={<RoomTypeFormPage />} />

      <Route path="/room-types/:roomTypeId" element={<RoomTypeDetailPage />} />
    </>
  );
}
